module.exports = __webpack_public_path__ + "static/img/103354.6a2e32e7.png";